import { appApiClient } from "@/core/plugins/apollo";
import { FetchPolicy } from "@apollo/client";
import { FetchDataPolicy } from "@/core/enums/ApolloEnums";

export const mutation = async (
  m,
  payload: unknown | null = null
  // errorPolicy: ErrorPolicy = ErrorPolicy.all
) => {
  const { data } = await appApiClient.mutate({
    mutation: m,
    variables: payload,
    // errorPolicy: errorPolicy,
    // // Update the cache with the result
    // // The query will be updated with the optimistic response
    // // and then with the real result of the mutation
    // update: (store, { data: { addTag } }) => {
    //   // Read the data from our cache for this query.
    //   let data = store.readQuery({ query: m });
    //   // Add our tag from the mutation to the end
    //   data = {
    //     ...data,
    //     tags: [...data.tags, addTag],
    //   };
    //   // Write our data back to the cache.
    //   store.writeQuery({ query: TAGS_QUERY, data });
    // },
    // // Optimistic UI
    // // Will be treated as a 'fake' result as soon as the request is made
    // // so that the UI can react quickly and the user be happy
    // // optimisticResponse: {
    // //   __typename: 'Mutation',
    // //   addTag: {
    // //     __typename: 'Tag',
    // //     id: -1,
    // //     label: newTag,
    // //   },
    // // },
  });

  return data;
};

export const query = async (
  q,
  payload = null,
  fetchPolicy: FetchPolicy = FetchDataPolicy.networkOnly
  // errorPolicy: ErrorPolicy = ErrorPolicy.all
) => {
  const { data } = await appApiClient.query({
    query: q,
    variables: payload,
    fetchPolicy: fetchPolicy,
    // errorPolicy: errorPolicy,
  });

  return data;
};
